import { createContextKey, diag, context } from '@opentelemetry/api';
import { isAttributeValue } from '@opentelemetry/core';

const CONTEXT_ATTRIBUTES_KEY = createContextKey('OpenTelemetry Context Attributes');
const globalAttributes = {};
function setGlobalAttribute(key, value) {
    if (value == null)
        return;
    if (key.length === 0) {
        diag.warn(`Invalid attribute key: ${key}`);
        return;
    }
    if (!isAttributeValue(value)) {
        diag.warn(`Invalid attribute value set for key: ${key}`);
        return;
    }
    globalAttributes[key] = value;
}
function setGlobalAttributes(attributes) {
    for (const [k, v] of Object.entries(attributes))
        setGlobalAttribute(k, v);
}
function getGlobalAttributes() {
    return globalAttributes;
}
function setContextAttribute(context, key, value) {
    return context.setValue(CONTEXT_ATTRIBUTES_KEY, Object.assign(Object.assign({}, (context.getValue(CONTEXT_ATTRIBUTES_KEY) || {})), { [key]: value }));
}
function setContextAttributes(context, attributes) {
    return context.setValue(CONTEXT_ATTRIBUTES_KEY, Object.assign(Object.assign({}, (context.getValue(CONTEXT_ATTRIBUTES_KEY) || {})), (attributes || {})));
}
function getContextAttributes(context) {
    return context.getValue(CONTEXT_ATTRIBUTES_KEY);
}

/**
 * Implementation of the {@link SpanProcessor} that simply forwards all
 * received events to a list of {@link SpanProcessor}s.
 */
class GlobalAttributesSpanProcessor {
    constructor() { }
    onStart(span, context) {
        const attributes = getGlobalAttributes();
        if (attributes) {
            for (const [k, v] of Object.entries(attributes))
                span.setAttribute(k, v);
        }
    }
    onEnd(_span) { }
    forceFlush() {
        return Promise.resolve();
    }
    shutdown() {
        return Promise.resolve();
    }
}

/**
 * Implementation of the {@link LogRecordProcessor} that simply forwards all
 * received events to a list of {@link LogRecordProcessor}s.
 */
class GlobalAttributesLogRecordProcessor {
    async forceFlush() {
        return Promise.resolve();
    }
    onEmit(logRecord) {
        const attributes = getGlobalAttributes();
        if (attributes) {
            for (const [k, v] of Object.entries(attributes))
                logRecord.setAttribute(k, v);
        }
    }
    async shutdown() {
        return Promise.resolve();
    }
}

/**
 * Implementation of the {@link SpanProcessor} that simply forwards all
 * received events to a list of {@link SpanProcessor}s.
 */
class ContextAttributesSpanProcessor {
    onStart(span, context) {
        const contextAttributes = getContextAttributes(context);
        if (contextAttributes) {
            for (const [k, v] of Object.entries(contextAttributes))
                span.setAttribute(k, v);
        }
    }
    onEnd(_span) { }
    forceFlush() {
        return Promise.resolve();
    }
    shutdown() {
        return Promise.resolve();
    }
}

/**
 * Implementation of the {@link LogRecordProcessor} that simply forwards all
 * received events to a list of {@link LogRecordProcessor}s.
 */
class ContextAttributesLogRecordProcessor {
    async forceFlush() {
        return Promise.resolve();
    }
    onEmit(logRecord) {
        const contextAttributes = getContextAttributes(context.active());
        if (contextAttributes) {
            for (const [k, v] of Object.entries(contextAttributes))
                logRecord.setAttribute(k, v);
        }
    }
    async shutdown() {
        return Promise.resolve();
    }
}

export { ContextAttributesLogRecordProcessor, ContextAttributesSpanProcessor, GlobalAttributesLogRecordProcessor, GlobalAttributesSpanProcessor, getContextAttributes, getGlobalAttributes, setContextAttribute, setContextAttributes, setGlobalAttribute, setGlobalAttributes };
